import React from 'react';

export const commentTypes = [
    {
        id: 'FILM_CLIPS_STILLS',
        value: 'FILM_CLIPS_STILLS',
        name: 'Film Clips & Stills',
        label: 'Film Clips & Stills',
    },
    {
        id: 'REMAKES_SEQUELS',
        value: 'REMAKES_SEQUELS',
        name: 'Remakes, Sequels, and/or Spin Offs',
        label: 'Remakes, Sequels, and/or Spin Offs',
    },
    {
        id: 'LEGITIMATE_STAGE',
        value: 'LEGITIMATE_STAGE',
        name: 'Legitimate Stage',
        label: 'Legitimate Stage',
    },
    {
        id: 'ANCILLARY_RIGHTS',
        value: 'ANCILLARY_RIGHTS',
        name: 'Ancillary Rights',
        label: 'Ancillary Rights',
    },
    {
        id: 'TITLE_MERCHANDISING_COMMERCIAL_TIE_INS',
        value: 'TITLE_MERCHANDISING_COMMERCIAL_TIE_INS',
        name: 'Title Merchandising & Commercial Tie-Ins',
        label: 'Title Merchandising & Commercial Tie-Ins',
    },
    { id: 'PAID_AD_MEMO', value: 'PAID_AD_MEMO', name: 'Paid Ad Memo', label: 'Paid Ad Memo' },
    { id: 'BILLING_BLOCK', value: 'BILLING_BLOCK', name: 'Billing Block', label: 'Billing Block' },
    { id: 'TITLE_CREDITS', value: 'TITLE_CREDITS', name: 'Title Credits', label: 'Title Credits' },
    {
        id: 'ARTWORK_RESTRICTIONS',
        value: 'ARTWORK_RESTRICTIONS',
        name: 'Artwork Restrictions',
        label: 'Artwork Restrictions',
    },
    { id: 'DUBBING', value: 'DUBBING', name: 'Dubbing', label: 'Dubbing' },
    { id: 'SERVICING', value: 'SERVICING', name: 'Servicing', label: 'Servicing' },
    { id: 'MPAA', value: 'MPAA', name: 'MPAA', label: 'MPAA' },
    { id: 'CRTOO', value: 'CRTOO', name: 'CRTOO', label: 'CRTOO' },
    { id: 'MUSIC', value: 'MUSIC', name: 'Music', label: 'Music' },
    { id: 'RIGHTSTRAND', value: 'RIGHTSTRAND', name: 'Right Strand', label: 'Right Strand' },
    { id: 'INFO_CODE', value: 'INFO_CODE', name: 'Info Code', label: 'Info Code' },
    { id: 'PRODUCT', value: 'PRODUCT', name: 'Product', label: 'Product' },
    {
        id: 'PROMOTIONAL_MATERIALS',
        value: 'PROMOTIONAL_MATERIALS',
        name: 'Promotional Materials',
        label: 'Promotional Materials',
    },
];

/**
 * Function to get the name of a comment type based on its ID.
 *
 * This function searches through the commentTypes array to find the comment type
 * that matches the provided ID. If found, it returns the name of the comment type.
 * If not found, it returns "ID not found".
 *
 * @function getCommentTypeName
 * @param {string} id - The ID of the comment type.
 * @return {string} - The name of the comment type or "ID not found" if not found.
 */
export function getCommentTypeName(id) {
    const comment = commentTypes.find((item) => item.id === id);
    return comment ? comment.name : 'ID not found';
}

/**
 * CommentTypeRenderer Component
 *
 * This component is a cell renderer for AG Grid that displays the name of a comment type.
 * It takes the comment type ID from the data and uses the getCommentTypeName function
 * to get the corresponding name.
 *
 * @param {Object} props - The props object containing the data for the cell.
 * @return {JSX.Element} - The rendered span element displaying the comment type name.
 */
export const CommentTypeRenderer = (props) => {
    return <span>{getCommentTypeName(props.data.commentType)}</span>;
};
